import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";
import { ProductWiseRUConfigJson } from "../../DynamicFormsJson/Transaction/productWiseRUConfigJson";
import {
  getAllActiveProductSortByBrand
} from "../../Slice/product.slice";
import {
  getRuWiseProductConfigurationById
} from "../../Slice/ruWiseProductConfig.slice";
import { getYear } from "../../Slice/year.slice";
import { ButtonCompo } from "../../components/Comman/Button";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import MaterialUITableWithTextField from "../../components/Comman/RT/MaterialUITableWithTextField";
import DynamicFormWithoutValidation from "../../components/dynamicscreens/DynamicFormWithoutValidation";
import { withRouter } from "../../components/withRouter";
import { redColor } from "../../config/ColorObj";
import { mandatoryCheck, ValidationCheck } from "../../config/ValidationCheck";
import endpoint from "../../config/endpoints";
import {
  nameAlreadyPresentMsg,
  noInternetMsg,
  saveFailedMsg,
  savemsg,
  saveWarningMsg,
  serverMsg,
  updateData
} from "../../config/messageconstant";
import { apiGet, apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";

const MemoizedMaterialUITableWithTextField = React.memo(
  MaterialUITableWithTextField
);

// Child component wrapped with React.memo to prevent re-renders
const ChildComponent = memo(({ onClick }) => {
  console.log("Child Component Rendered"); // Debugging log
  return <button onClick={onClick}>Click Me</button>;
});

const ProductWiseRUConfigFormForDisabledRU = ({
  showLoador,
  showNotification,
  getAllActiveProductSortByBrand,
  getYear,
  getRuWiseProductConfigurationById,
  yearList,
  productList,
}) => {
  const [formErrors, setformErrors] = useState({});
  const [fieldData, setfieldData] = useState({});
  const [rowData, setRowData] = useState({});
  const [searchValue, setsearchValue] = useState("");
  const [ruConfigurationList, setruConfigurationList] = useState([]);
  const params = useParams();
  const navigate = useNavigate();

  const dynamicMasterData = useMemo(
    () => ({
      yearDetail: yearList.year,
    }),
    [yearList.year]
  );

  useEffect(() => {
    (async () => {
      showLoador({ loador: true });

      await getYear().then(({ success }) => {
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });

      await getAllActiveProductSortByBrand().
        then(async ({ response, success }) => {
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            setruConfigurationList(response);
            if (params.id) {
              await getById(params.id);
            }
          }
        });
      showLoador({ loador: false });

    })();
  }, []);

  const getById = async (id) => {
    showLoador({ loador: true });
    await getRuWiseProductConfigurationById({ id: id }).then(
      ({ response, success }) => {
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          let rowData = response;
          editData(rowData);
        }
      }
    );
    showLoador({ loador: false });
  };

  const onDataChange = async (fieldName, newValue) => {
    const dataToSearch = {};
    const dataToReset = { ...fieldData };
    let listError = false;

    if (fieldName == "year") {
      const updatedProductList = ruConfigurationList.map((dataObj) => ({
        ...dataObj,
        ruQty: 1,
        primaryQty: 1,
      }));
      setruConfigurationList(updatedProductList);
    }

    if (fieldName == "fromdate" && dataToReset.todate) {
      await getBill(
        newValue.format("DD-MM-YYYY"),
        fieldData.todate.format("DD-MM-YYYY")
      );
    }
    if (fieldName == "todate" && dataToReset.fromdate) {
      await getBill(
        fieldData.fromdate.format("DD-MM-YYYY"),
        newValue.format("DD-MM-YYYY")
      );
    }
    ProductWiseRUConfigJson.fieldMeta.map((currentField) => {
      if (currentField.getDate && currentField.dataKey === fieldName) {
        dataToReset[currentField.getDate] = newValue.add(365, "day");
      }
      if (currentField.dataKey === fieldName && currentField.getListId) {
        const masterKeyList = currentField.getListId.split(",");
        masterKeyList.map((key) => {
          if (fieldName === key) {
            dataToSearch[key] = newValue;
          } else if (fieldData[key]) {
            dataToSearch[key] = fieldData[key];
          }
          return null;
        });

        getListById(dataToSearch);
      }
      if (currentField.getListFrom) {
        const masterKeyList = currentField.getListFrom.split(",");
        masterKeyList.map((key) => {
          if (key == fieldName && dataToReset[key]) {
            delete dataToReset[currentField.dataKey];
          }
        });
      }
      if (
        !listError &&
        fieldData[currentField.dataKey] &&
        currentField.controlType != "datepicker" &&
        currentField.getListFrom == undefined
      ) {
        dataToReset[currentField.dataKey] = fieldData[currentField.dataKey];
      }
      return null;
    });

    dataToReset[fieldName] = newValue;

    setfieldData(dataToReset);
  };

  const editData = (data) => {
    let newDataToSet = productList?.activeAllProductSortByBrand.map(
      (dataObj) => {
        let filterData =
          data.retailUnitProductConfigurationDetails.length !== 0 &&
          data.retailUnitProductConfigurationDetails.find(
            (row) => row.productId === dataObj.id
          );

        let dataObject = filterData
          ? {
            ...filterData,
            id: filterData.id,
            productId: dataObj.id,
            name: dataObj.name,
            ruQty: filterData.ruQty,
          }
          : { ...dataObj };

        return dataObject;
      }
    );

    setruConfigurationList(newDataToSet);

    setRowData(data);

    let fieldData = {
      name: data.name !== null ? data.name : "",
      year: data.yearId !== null ? data.yearId : "",
    };

    setfieldData(fieldData);
  };

  const setListDetails = useCallback(({ row }) => {
    setruConfigurationList(row);
  }, []);

  const onSubmitData = () => {
    if (checkValidationOnSubmit()) {
      let dataToSend = {};

      let error = false;

      const rowList = ruConfigurationList.map((rowObj) => {
        if (
          rowObj.ruQty.toString() == "" ||
          rowObj.primaryQty.toString() == ""
        ) {
          error = true;
        }
        rowObj = {
          ...rowObj,
          primaryQtyErr: rowObj.primaryQty.toString() == "" ? 1 : 0,
          ruPerPrimaryQtyErr: rowObj.ruQty.toString() == "" ? 1 : 0,
        };
        return rowObj;
      });

      setruConfigurationList(rowList);

      if (params.id) {
        dataToSend = {
          id: params.id,
          name: fieldData.name,
          year: { id: fieldData.year },
          retailUnitProductConfigurationDetails: ruConfigurationList.map(
            (dataObj) => ({
              id: dataObj.id,
              product: { id: dataObj.productId },
              uom: { id: dataObj.stakeHolderUomId },
              primaryQty: +dataObj.primaryQty,
              ruQty: +dataObj.ruQty,
            })
          ),
        };
      } else {
        dataToSend = {
          name: fieldData.name,
          year: { id: fieldData.year },
          retailUnitProductConfigurationDetails: ruConfigurationList.map(
            (dataObj) => ({
              product: { id: dataObj.productId },
              uom: { id: dataObj.stakeHolderUomId },
              primaryQty: +dataObj.primaryQty,
              ruQty: +dataObj.ruQty,
            })
          ),
        };
      }

      console.log(dataToSend);

      if (!error) {
        swal({
          title: "Are you sure?",
          text: params.id ? updateData : saveWarningMsg,
          icon: "warning",
          buttons: true,
          dangerMode: true,
        }).then((willDelete) => {
          if (willDelete) {
            callBeforeSaveMethod(dataToSend, rowData);
          }
        });
      }
    }
  };

  const callBeforeSaveMethod = (dataToSave, editData) => {
    if (navigator.onLine) {
      if (
        Object.keys(editData).length == 0 ||
        (Object.keys(editData).length != 0 && editData.name != dataToSave.name)
      ) {
        showLoador({ loador: true });
        apiGet({
          url:
            endpoint.ruProductConfigHeader +
            "/check-name-present-or-not?name=" +
            dataToSave.name,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (success) {
            if (data.data.error) {
              showNotification({
                msg: nameAlreadyPresentMsg,
                severity: "error",
              });
            } else {
              onSave(dataToSave);
            }
          }
        });
      } else {
        onSave(dataToSave);
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  const onSave = (dataToSave) => {
    if (navigator.onLine) {
      showLoador({ loador: true });
      apiPost({
        url: endpoint.ruProductConfigHeader,
        postBody: dataToSave,
      }).then(({ data, success }) => {
        showLoador({ loador: false });

        if (success) {
          showNotification({ msg: savemsg });
          navigate(-1);
        } else {
          showNotification({ msg: saveFailedMsg, severity: "error" });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  const checkValidationOnSubmit = () => {
    const mandatoryCheckErrors = mandatoryCheck({
      fieldData,
      fieldMeta: ProductWiseRUConfigJson.fieldMeta,
    });
    setformErrors(mandatoryCheckErrors.formErrors);

    if (mandatoryCheckErrors.formValid) {
      const ValidationCheckErrors = ValidationCheck({
        fieldData,
        fieldMeta: ProductWiseRUConfigJson.fieldMeta,
      });
      setformErrors(ValidationCheckErrors.formErrors);

      return ValidationCheckErrors.formValid;
    } else {
      return false;
    }
  };

  const onSearch = (searchValue) => {
    setsearchValue(searchValue);
  };

  const filteredTableData = useMemo(() => {
    return ruConfigurationList.filter((currentRow) => {
      let isValid = false;
      let productName = currentRow.name || "-";
      let stakeHolderUomName = currentRow.stakeHolderUomName || "-";

      if (productName.toLowerCase().includes(searchValue.toLowerCase())) {
        isValid = true;
      }
      if (
        stakeHolderUomName.toLowerCase().includes(searchValue.toLowerCase())
      ) {
        isValid = true;
      }
      return isValid;
    });
  }, [ruConfigurationList, searchValue]);

  return (
    <Paper
      sx={{
        padding: 2,
      }}
    >
      <DynamicFormWithoutValidation
        dynamicMasterData={dynamicMasterData}
        screenTitle={ProductWiseRUConfigJson.screenTitle}
        fieldMeta={ProductWiseRUConfigJson.fieldMeta}
        apiBaseURL={ProductWiseRUConfigJson.apiBaseURL}
        formErrors={formErrors}
        showSaveBtn={ProductWiseRUConfigJson.showSaveBtn}
        showSaveBtnMain={false}
        fieldData={fieldData}
        onDataChange={onDataChange}
        showBackToList={true}
      />
      <br />
      <>
        <LandingScreenHeader
          screenTitle={""}
          showSearchBox={true}
          showTable={true}
          showFilter={false}
          showPdfDownload={false}
          showExcelDownload={false}
          onSearch={onSearch}
        />

        <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Sr. No.</TableCell>
                <TableCell align="center">Product Name</TableCell>
                <TableCell align="center" sx={{ width: "15%" }}>
                  Primary UOM
                </TableCell>
                <TableCell align="center" sx={{ width: "15%" }}>
                  Primary Quantity
                </TableCell>
                <TableCell align="center" sx={{ width: "15%" }}>
                  RU Factor
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredTableData.length > 0 ? (
                filteredTableData.map((row, rowIndex) => (
                  <TableRow key={row.id}>
                    <TableCell align="center">{rowIndex + 1}</TableCell>
                    <TableCell align="left">{row.name || "-"}</TableCell>
                    <TableCell align="center">
                      {row.stakeHolderUomName || "-"}
                    </TableCell>

                    <TableCell align="right" justify="center">
                      <input
                        className="customTextfield"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="Enter Primary Quantity"
                        value={row.primaryQty}
                        onChange={(e) => {
                          const updatedList = [...ruConfigurationList];
                          const idx = updatedList.findIndex(item => item.id == row.id);

                          if (idx !== -1) {
                            const updatedRow = { ...updatedList[idx] };
                            updatedRow.primaryQty = e.target.value;
                            updatedList[idx] = updatedRow;
                          }
                          setListDetails({ row: updatedList });
                        }}
                      />
                      <span style={{ color: redColor, fontSize: "12px" }}>
                        {row.primaryQty === ""
                          ? "Primary Quantity Required"
                          : " "}
                      </span>
                    </TableCell>
                    <TableCell align="center">{row.ruQty || "-"}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No data found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </>
      <br />
      <Grid
        item
        sm={12}
        xs={12}
        md={12}
        lg={12}
        container
        justifyContent="right"
      >
        <ButtonCompo
          size="medium"
          type="Submit"
          variant="contained"
          name="Submit"
          onClick={onSubmitData}
        />
      </Grid>
    </Paper>
  );
};

const mapStateToProps = (state) => ({
  yearList: state.year,
  productList: state.product,
  ruWiseConfigByIdList: state.ruProductConfigHeader,
});
const mapDispatchToProps = {
  showLoador,
  showNotification,
  getAllActiveProductSortByBrand,
  getYear,
  getRuWiseProductConfigurationById,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(ProductWiseRUConfigFormForDisabledRU);
